<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 12H20"
            stroke="black"
            stroke-width="2.5"
            stroke-linecap="round"
        />
    </svg>
</template>
